<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label for="post_title" class="form-control-label">{{ $t('post.title') }}</label>
      <input
          id="post_title"
          v-model="item.title"
          :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
      @input="handleUpdateField('title', $event.target.value)">
      <div v-if="isInvalid('title')" class="invalid-feedback">{{ violations.title }}</div>
    </div>

    <div class="form-group">
      <label for="post_summary" class="form-control-label">{{ $t('post.summary') }}</label>
      <input
          id="post_summary"
          v-model="item.summary"
          :class="['form-control', isInvalid('summary') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('summary', $event.target.value)">
      <div v-if="isInvalid('summary')" class="invalid-feedback">{{ violations.summary }}</div>
    </div>

    <div class="form-group">
      <label for="post_description" class="form-control-label">{{ $t('post.description') }}</label>
      <textarea
          id="post_description"
          v-model="item.description"
          :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
          placeholder=""
          @input="handleUpdateField('description', $event.target.value)"
          rows="5"
      ></textarea>
      <div v-if="isInvalid('description')" class="invalid-feedback">{{ violations.description }}</div>
    </div>

    <upload-image :item="item" property="images" :multiple="true" label="Images"></upload-image>

    <item-edit-actions :item="item" entity="Post" path="post"></item-edit-actions>
  </form>
</template>

<script>
import ItemEditActions from '../layout/ItemEditActions'
import UploadImage from '../layout/UploadImage'

export default {
  components: {
    ItemEditActions,
    UploadImage,
  },

  props: {
    handleUpdateField: {
      type: Function,
      required: true
    },
    handleSubmit: {
      type: Function,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
  }
}
</script>
